// @flow
import styled from '@emotion/styled';

const FormGroupAuth: React$ComponentType<{}> = styled.div`
	margin-bottom: 6px;
`;

export default FormGroupAuth;
